import styled, { css } from 'styled-components'
import media from 'styled-media-query'

const Container = styled.div`
  ${({ theme }) => css`
    padding: 0 ${theme.spacings.small};
    max-width: ${theme.grid.container};
    margin: 0 auto;
    width: 100%;

    ${media.lessThan('medium')`
      padding-right: ${theme.spacings.xxsmall};
      max-width: 100vw;
    `}
  `}
`

export default Container
